_ = require('lodash')
moment = require('moment')

GroupRankingCtrl = ($scope ,$translate ,$filter , $location ,groupRankingService ) ->
  lstRanking = this
  lstRanking.pageSize = 4
  lstRanking.lstEvents = []
  lstRanking.currentPage = 0
  lstRanking.isLoading = true
  lstRanking.noResults = false
  lstRanking.totalPages = 0
  lstRanking.showCreateButton = false

  lstRanking.loadMore = ->
    lstRanking.isLoading = true
    lstRanking.currentPage++
    params =
      group_id : $scope.groupDetail.id
      page : lstRanking.currentPage
      page_size : lstRanking.pageSize
    groupRankingService.listRanking(params)
    .then (data) ->
      lstRanking.lstEvents = _.union(lstRanking.lstEvents, data.events)
      lstRanking.totalPages = data.total_pages
      lstRanking.noResults = lstRanking.lstEvents.length == 0
    .finally ->
      lstRanking.isLoading = false

  lstRanking.hasMore = ->
    lstRanking.noResults == false && lstRanking.currentPage isnt lstRanking.totalPages

  groupRankingService.checkJoinGroup($scope.groupDetail.id).then (data) ->
    lstRanking.showCreateButton = data.joined
  
  lstRanking.displayPeriod = (startTime, endTime) ->
    reText = ""
    if !startTime && !endTime
      return reText
    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME')
    reText += ": "
    reText += lstRanking.displayDateByLang(startTime)
    reText += " ~ "
    reText += lstRanking.displayDateByLang(endTime)
    reText

  lstRanking.displayDateByLang = (time) ->
    if !time
      return ""
    d = moment(time)
    formatText = 'YYYY-MM-DD (ddd)'
    if /^ja/i.test $translate.preferredLanguage()
      formatText = 'LL (ddd)'
      moment.locale('ja')
    d.format(formatText)

  lstRanking.displayParticipants = (number) ->
    reText = $filter('translate')('_RANKING_GROUP.PARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText

  lstRanking.goToCreatePage = ->
    url = '/group-event/registration?id=' + $scope.groupDetail.id
    $location.url(url)

  lstRanking.displayNoParticipants = (number) ->
    reText = $filter('translate')('_RANKING_GROUP.NONPARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText
  lstRanking.showGroupEventRanking = (id) ->
    $location.path('/group-event/' + id + '/ranking')

  lstRanking.displayImageRanking = (number) ->
    switch number
      when 1 then 'ranking-one'
      when 2 then 'ranking-two'
      when 3 then 'ranking-three'
      when "-" then 'ranking-not-join-yet'
      else 'ranking-over-three'

  lstRanking.loadMore()
  lstRanking

GroupRankingCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  '$location'
  'groupRankingService'
]

module.exports = GroupRankingCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-ranking/group-ranking-controller.coffee